import Axios from "axios";
import { CMError } from "./cm-error.model";
import Vue from "vue";
import { format } from "date-fns";

Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.MeetupAPI) this.$meetupApi = options.MeetupAPI;
        else if (options.parent && options.parent.$meetupApi)
            this.$meetupApi = options.parent.$meetupApi;
    }
});

export function makeMeetupAPI(token, conf) {
    return new MeetupAPI(token, conf);
}

export class MeetupAPI {
    constructor(token, conf) {
        this.__ax = null;
        this._conf = conf;
        this._token = token;
    }

    get _ax() {
        if (this.__ax === null) {
            this.__ax = Axios.create({
                baseURL:
                    process.env.VUE_APP_MEETUP_API_ENDPOINT ||
                    "https://cm-meetup-server.azurewebsites.net/public/api",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + this._token
                }
            });
        }
        return this.__ax;
    }

    async getMeetup(slug) {
        try {
            const res = await this._ax.get("/meetup/byslug/" + slug)
            return res.data;
        } catch (error) {
            return this._handleError(error)
        }
    }

    async getMeetupById(id) {
        try {
            const res = await this._ax.get("/meetup/" + id)
            return res.data;
        } catch (error) {
            return this._handleError(error)
        }
    }

    async getMeetupAttendees(id, type) {
        try {
            const res = await this._ax.get("/meetup/" + id + "/attendees/" + type)
            return res.data;
        } catch (error) {
            return this._handleError(error)
        }
    }

    async addUsersFromWaitingList(payload) {
        try {
            const res = await this._ax.post("/meetup/addfromwaitinglist", payload)
            return res.data
        } catch (error) {
            console.error(error);
            return this._handleError(error)
        }
    }

    async getVenues(id) {
        try {
            const res = await this._ax.get("/meetup/" + id + "/venues")
            return res.data.data;
        } catch (error) {
            return this._handleError(error)
        }
    }

    async getMeetups(id, page, perPage, filters) {
        let date;
        if (filters.live !== null) {
            if (filters.live) {
                date =
                    "&from_datetime=" +
                    format(new Date(), "yyyy-MM-dd 00:00:00");
            } else {
                date =
                    "&to_datetime=" + format(new Date(), "yyyy-MM-dd 00:00:00");
            }
        }
        try {
            const res = await this._ax.get(
                "/meetup?organizer_id=" +
                id +
                "&page=" +
                page +
                "&per_page=" +
                perPage +
                "&name=" +
                filters.name +
                "&status=" +
                filters.status +
                (date ? date : "")
            );
            return res.data.data;
        } catch (error) {
            return this._handleError(error);
        }
    }

    async getMeetupProposals(id, page, perPage, states) {
        try {
            const papers = await this._ax.post('/meetup/' + id + '/proposals', {
                page: page,
                per_page: perPage,
                filters: {
                    state: states
                }
            });
            return papers.data.data.proposals;
        } catch (error) {
            this._handleError(error);
        }
    }

    async approveProposal(meetupId, paperId) {
        try {
            const res = await this._ax.put(`/meetup/${meetupId}/proposals/${paperId}/approve`)
            return res.data
        } catch (error) {
            console.error(error)
            this._handleError(error)
        }
    }

    async rejectProposal(meetupId, paperId) {
        try {
            const res = await this._ax.put(`/meetup/${meetupId}/proposals/${paperId}/reject`)
            return res.data
        } catch (error) {
            console.error(error)
            this._handleError(error)
        }
    }


    async addMeetup(meetup, cover) {
        delete meetup.banner;
        try {
            const res = await this._ax.post("/meetup", meetup);
            const mid = res.data.data.id;
            if (cover) {
                const coverP = await this._ax.put("/meetup/banner", {
                    id: mid,
                    image: cover
                });
                return coverP;
            } else {
                return mid;
            }
        } catch (error) {
            this._handleError(error);
        }
    }
    async updateMeetup(meetup, cover) {
        try {
            const res = await this._ax.put("/meetup", meetup);
            if (cover) {
                const coverP = await this._ax.put("/meetup/banner", {
                    id: meetup.id,
                    image: cover
                });
                return coverP;
            } else {
                return res.data.data;
            }
        } catch (error) {
            this._handleError(error);
        }
    }

    async deleteMeetup(id) {
        try {
            const res = await this._ax.delete(`/meetup?id=${id}`);
            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async sendCustomEmail(meetupId, data, checkin) {
        let participants = "";
        if (checkin) {
            participants = "/participants";
        }
        try {
            const res = await this._ax.post(`/meetup/${meetupId}/customEmail${participants}`, data);
            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async sendCustomEmailTest(meetupId, data, testEmail) {
        data.testEmail = testEmail;
        try {
            const res = await this._ax.post(`/meetup/${meetupId}/customEmail/test`, data);
            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async activateReminder(meetupId) {
        try {
            const res = await this._ax.put(`/meetup/${meetupId}/reminder/activate`);
            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async deactivateReminder(meetupId) {
        try {
            const res = await this._ax.put(`/meetup/${meetupId}/reminder/deactivate`);
            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async getMeetupsStats(cid, year) {
        try {
            const res = await this._ax.get(`/organizers/${cid}/stats/${year}`);
            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async exportAttendeesToCsv(id) {
        try {
            const res = await this._ax.get(`/report/meetup/${id}/attendees/v2`,
            {
                responseType: "blob"
            });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${id}-attendees_list.csv`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            this._handleError(error);
        }
    }

    _handleError(error) {
        if (error.response) {
            let errMess = this._extractError(error.response.data);
            console.error(errMess);
            if (error.response.status === 401) {
                throw new CMError(
                    "UnauthorizedRedirect",
                    errMess
                );
            }
            if (this._checkTokenDelete(error.response.data.errors)) {
                console.error("Invalid or expired token");
                throw new CMError("Unauthorized", "Invalid or expired token");
            }
            throw new CMError("CMServerError", errMess);
        } else if (error.request) {
            console.error("Error on request => Server does not respond");
            throw new Error("Error on request => Server does not respond");
        } else {
            console.error("Client error => " + error.message);
            throw new Error("Client error => " + error.message);
        }
    }

    _checkTokenDelete(errors) {
        if (!errors) {
            return false;
        }
        const tError = errors.findIndex(elem => {
            return (
                elem.name === "CMInvalidTokenError" ||
                elem.name === "CMInvalidExpiredError"
            );
        });
        return tError !== -1;
    }

    _extractError(data) {
        let errMess = "";
        if (data.errors && Array.isArray(data.errors)) {
            const errMess = data.errors.reduce((errT, err) => {
                return (errT += `[${err.name}] => ${err.message};`);
            }, "");
        } else if (data.error) {
            errMess = data.error;
        } else {
            errMess = "Unknow error";
        }
        return errMess;
    }
}
